import React, { useEffect, useState } from 'react';
import { Box, Button, Grid, Typography, useTheme } from '@mui/material';

import SubtitlesIcon from '@mui/icons-material/Subtitles';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

import CreditCardForm from '../CreditCardForm';
import {
  getPaymentPlansById,
  paymentWithCard,
} from '@shared/services/services';
import useWindowSize from '@shared/hooks/useWindowsSize';

import { sxStyled } from './styles';
import { MaterialDialog } from '@shared/components/Dialogs';

const PaymentMethod = ({ idLink, payment, handleBack }) => {
  const theme = useTheme();

  const sxStyle = sxStyled(theme);

  const screenSize = useWindowSize();
  const [mediosDePago, setMediosDePago] = useState(null);
  const [tarjetaCredito, setTarjetaCredito] = useState(null);
  const [openDialog, setOpenDialog] = useState(null);
  const [pago, setPago] = useState({});
  const [success, setSuccess] = useState(null);
  const [cachError, setCachError] = useState('');

  const getPaymentsPans = () => {
    getPaymentPlansById(7).then(result => {
      setCreditAndDebitCard(result);
    });
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        getPaymentsPans();
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, []);

  const payWithCard = formData => {
    console.error('formData', formData);

    const data = { ...payment, ...formData };
    data.currency = 'ARS';
    data.payment_plan_id = pago.id;
    data.cap_amount = parseInt(data.amount);
    data.amount = parseFloat(getTotal(pago.coefficient)).toFixed(2).toString();
    data.rec_amount = textoInteresParentesis(pago);

    data.agency_business_name = null;
    data.agency_name = null;

    delete data.created_at;
    delete data.error_status;
    delete data.expire_at;
    delete data.id;
    delete data.link;
    delete data.payment_date;
    delete data.transaction_id;

    if (data.file_number == '') {
      data.file_number = '-';
    }

    paymentWithCard(idLink, data)
      .then(res => {
        if (res?.status) {
          setSuccess(true);
        } else {
          setSuccess(false);
          setCachError(res.message);
        }
      })
      .catch(err => {
        setSuccess(false);
        setCachError(err.response.data.message);
      });
  };

  const setCreditAndDebitCard = result => {
    const paymentPlansFormatted = result.reduce(
      (acum, act) => {
        if (act.payment_type.payment_method_type === 'Credito') {
          return {
            credito: [...acum.credito, act],
            debito: [...acum.debito],
          };
        } else if (act.payment_type.payment_method_type === 'Debito') {
          return {
            credito: [...acum.credito],
            debito: [...acum.debito, act],
          };
        }
      },
      { credito: [], debito: [] }
    );

    let installmentGrouped = {};
    paymentPlansFormatted.credito.forEach(plan => {
      if (
        !Object.prototype.hasOwnProperty.call(
          installmentGrouped,
          `installment_${plan.installment.installments}`
        )
      ) {
        installmentGrouped[`installment_${plan.installment.installments}`] = {
          installmentInfo: {
            ...plan.installment,
          },
          planes: [plan],
        };
      } else {
        installmentGrouped[
          `installment_${plan.installment.installments}`
        ].planes.push(plan);
      }
    });

    setMediosDePago({
      credito: installmentGrouped,
      debito: paymentPlansFormatted.debito,
    });
  };

  const creditMethodText = obj => {
    const montoCoef =
      (parseFloat(payment.amount) * obj.planes[0].coefficient) /
      obj.installmentInfo.number_of_payments;
    return obj.installmentInfo.number_of_payments != 1
      ? ' A partir de $' +
          parseFloat(montoCoef.toFixed(2)).toLocaleString('es-AR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }) +
          ' cada una.'
      : ' A partir de $' +
          parseFloat(montoCoef.toFixed(2)).toLocaleString('es-AR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }) +
          '.';
  };

  const creditMethodTextInter = obj => {
    const montoCoef =
      (parseFloat(payment.amount) * obj.coefficient) /
      obj.installment.number_of_payments;
    return (
      ' de $' +
      parseFloat(montoCoef.toFixed(2)).toLocaleString('es-AR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }) +
      ' cada una.'
    );
  };

  const getTotal = coeficiente =>
    parseFloat((coeficiente * payment.amount).toFixed(2));

  const textoInteresParentesis = obj => {
    let montoCoef = parseFloat(payment.amount) * parseFloat(obj.coefficient);
    montoCoef = parseFloat((montoCoef - parseFloat(payment.amount)).toFixed(2));

    return montoCoef;
  };

  const listCard = () => {
    if (!openDialog) return;

    const payment =
      openDialog === 'credito' ? mediosDePago.credito : mediosDePago.debito;

    if (tarjetaCredito)
      return tarjetaCredito.map((item, i) => {
        return (
          <Button
            sx={sxStyle.buttonCard}
            onClick={() => handelClickCardCredit(item)}
            key={i}
          >
            <img
              width={'72px'}
              src={item.payment_type.logo ?? ''}
              alt={item.payment_type.brand}
            />
            <Typography sx={sxStyle.gridText}>
              <span>
                {item.installment.number_of_payments} cuota
                {item.installment.number_of_payments > 1 && 's '}
                {creditMethodTextInter(item)}
              </span>
              <span>
                Total ${getTotal(item.coefficient)} - Recargo $
                {textoInteresParentesis(item).toLocaleString('es-AR', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </span>
            </Typography>
          </Button>
        );
      });

    return Object.keys(payment).map((item, i) => {
      const installment = payment[item];
      const image =
        openDialog == 'debito'
          ? installment.payment_type
          : installment.installmentInfo;
      return (
        <Button
          sx={sxStyle.buttonCard}
          onClick={() =>
            openDialog == 'debito'
              ? handelClickCardDebir(installment)
              : handelClickCard(installment.planes)
          }
          key={i}
        >
          <img
            width={openDialog == 'debito' ? '72px' : '102px'}
            src={image?.logo ?? ''}
          />

          <Typography sx={sxStyle.label}>
            {openDialog == 'debito' ? (
              <>
                1 pago <span style={{ fontWeight: 400 }}> de</span>{' '}
                <span style={{ fontWeight: 600 }}>
                  {' '}
                  {`$${getTotal(installment.coefficient).toLocaleString(
                    'es-AR',
                    {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }
                  )}`}
                </span>
              </>
            ) : (
              creditMethodText(installment)
            )}
          </Typography>
        </Button>
      );
    });
  };

  const handelClickCard = value => {
    setTarjetaCredito(value);
  };

  const handelClickCardCredit = value => {
    setPago(value);
    handleCleanModal();
  };

  const handelClickCardDebir = value => {
    setPago(value);
    handleCleanModal();
  };

  const handleCleanModal = () => {
    setOpenDialog(null);
    setTarjetaCredito(null);
  };

  return (
    <>
      {Object.entries(pago).length > 0 && (
        <Grid sx={sxStyle.boxContainer}>
          <Grid item sx={sxStyle.dGrid} xs={12}>
            <Typography>
              {pago.installment.name} {pago.payment_type.brand}
            </Typography>
          </Grid>
          <Grid item sx={sxStyle.dGrid} xs={screenSize.width > 500 ? 4 : 12}>
            <Box component="p" sx={sxStyle.parrafo}>
              <span>
                {pago.installment.number_of_payments} cuota
                {pago.installment.number_of_payments > 1 && 's '}
                {creditMethodTextInter(pago)}
              </span>
            </Box>
          </Grid>
          <Grid item sx={sxStyle.dGrid} xs={screenSize.width > 500 ? 4 : 12}>
            <Box component="p" sx={sxStyle.parrafo}>
              Total a pagar $
              {getTotal(pago.coefficient).toLocaleString('es-AR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </Box>
          </Grid>
          <Grid sx={sxStyle.dFlex}>
            <Grid item sx={sxStyle.dGrid} xs={screenSize.width > 500 ? 3 : 8}>
              <Box component="p" sx={sxStyle.parrafo}>
                Recargo $
                {textoInteresParentesis(pago).toLocaleString('es-AR', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Box>
            </Grid>
            <Grid item sx={sxStyle.dGrid} xs={1}>
              <Button title="Modificar" onClick={() => setPago({})}>
                <AutorenewIcon />
              </Button>
            </Grid>
          </Grid>
        </Grid>
      )}

      {!Object.entries(pago).length > 0 ? (
        <Grid sx={{ p: { xs: 2, sm: 5 } }}>
          <Typography sx={sxStyle.cardTitle}>
            Seleccione el Medio de Pago
          </Typography>
          <Box
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignContent: 'flex-start',
              flexWrap: 'wrap',
            }}
          >
            <Box sx={sxStyle.cardBox} onClick={() => setOpenDialog('debito')}>
              <SubtitlesIcon sx={sxStyle.icon} />
              <Typography sx={sxStyle.cardText}>Tarjeta de Débito</Typography>
            </Box>
            <Box sx={sxStyle.cardBox} onClick={() => setOpenDialog('credito')}>
              <CreditCardIcon sx={sxStyle.icon} />
              <Typography sx={sxStyle.cardText}>Tarjeta de Crédito</Typography>
            </Box>
          </Box>
        </Grid>
      ) : (
        <>
          {success === null ? (
            <CreditCardForm payWithCard={payWithCard} />
          ) : (
            <Box
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignContent: 'flex-start',
              }}
            >
              <div style={{ textAlign: 'center' }}>
                {success ? (
                  <>
                    <Typography
                      variant="h5"
                      sx={sxStyle.titleNot}
                      display="flex"
                      alignItems="center"
                    >
                      <CheckCircleIcon
                        style={{
                          marginRight: '8px',
                          color: 'green',
                          fontSize: '32px',
                        }}
                      />
                      PAGO APROBADO
                    </Typography>

                    <Typography sx={sxStyle.text}>
                      Su pago se procesó correctamente.
                    </Typography>

                    <Box sx={{ width: '80%', m: 'auto' }}>
                      <Button
                        sx={sxStyle.btnAceptar}
                        onClick={() => {
                          setSuccess(null);
                          handleBack();
                        }}
                      >
                        Volver al inicio
                      </Button>
                    </Box>
                  </>
                ) : (
                  <>
                    <Typography
                      variant="h5"
                      sx={sxStyle.titleNot}
                      display="flex"
                      alignItems="center"
                    >
                      <CancelIcon
                        style={{
                          marginRight: '8px',
                          color: 'red',
                          fontSize: '32px',
                        }}
                      />{' '}
                      PAGO RECHAZADO
                    </Typography>

                    <Typography sx={sxStyle.text}>
                      Ocurrio un error al procesar su pago, por favor intentelo
                      nuevamente.
                    </Typography>

                    <Box sx={{ width: '80%', m: 'auto' }}>
                      <Typography sx={sxStyle.text}>{cachError}</Typography>
                      <Button
                        sx={sxStyle.btnAceptar}
                        onClick={() => setSuccess(null)}
                      >
                        Intentar Nuevamente
                      </Button>
                    </Box>
                  </>
                )}
              </div>
            </Box>
          )}
        </>
      )}

      <MaterialDialog
        isOpen={!!openDialog}
        handleIsOpen={handleCleanModal}
        actionsButton={false}
        maxWidth="sm"
        titleText={
          openDialog === 'debito'
            ? 'Seleccione la Tarjeta de Débito'
            : 'Seleccione la cantidad de pagos'
        }
      >
        {mediosDePago && listCard()}
      </MaterialDialog>
    </>
  );
};

export default PaymentMethod;
